/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderCustomerListResponse } from '../../models/order-customer-list-response';

export interface OrderCustomerControllerGetAll$Params {
  maintenance_only?: boolean;
  related_agreement_id?: number;
  progressive_agreement_id?: number;
  product_code_internal?: string;
  customer_related_registry_id?: number;
  billing_related_registry_id?: number;
  identifier?: string;
  protocol?: string;
  cig?: string;
  cup?: string;
  product_id?: Array<number>;
  status_id?: number;
  created_from_date?: string;
  created_to_date?: string;
  external_ref?: string;
  fulfillment_from_date?: string;
  fulfillment_to_date?: string;
  limit: number;
  skip: number;
  related_status_workflow_id?: number;
  order_by?: string;
  order_direction?: string;
}

export function orderCustomerControllerGetAll(http: HttpClient, rootUrl: string, params: OrderCustomerControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, orderCustomerControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('maintenance_only', params.maintenance_only, {});
    rb.query('related_agreement_id', params.related_agreement_id, {});
    rb.query('progressive_agreement_id', params.progressive_agreement_id, {});
    rb.query('product_code_internal', params.product_code_internal, {});
    rb.query('customer_related_registry_id', params.customer_related_registry_id, {});
    rb.query('billing_related_registry_id', params.billing_related_registry_id, {});
    rb.query('identifier', params.identifier, {});
    rb.query('protocol', params.protocol, {});
    rb.query('cig', params.cig, {});
    rb.query('cup', params.cup, {});
    rb.query('product_id', params.product_id, {});
    rb.query('status_id', params.status_id, {});
    rb.query('created_from_date', params.created_from_date, {});
    rb.query('created_to_date', params.created_to_date, {});
    rb.query('external_ref', params.external_ref, {});
    rb.query('fulfillment_from_date', params.fulfillment_from_date, {});
    rb.query('fulfillment_to_date', params.fulfillment_to_date, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('related_status_workflow_id', params.related_status_workflow_id, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderCustomerListResponse;
      }>;
    })
  );
}

orderCustomerControllerGetAll.PATH = '/order-customer';
